export const WITHDRAWALS_REQUESTS_TABLE_TEST_ID = 'withdrawal-requests-table';
export const WITHDRAW_FUNDS_BUTTON = 'withdraw-funds-button';
export const WITHDRAWALS_ACCOUNT_FILTER_TEST_ID = 'withdrawals-account-filter';

export const WITHDRAW_MODAL = {
  FROM_ACCOUNT: 'withdrawal-modal-from-account',
  TO_ACCOUNT: 'withdrawal-modal-to-account',
  AMOUNT: 'withdrawal-modal-amount-input',
  END_TO_END_ID: 'withdrawal-modal-e2e-id-input',
  WITHDRAW_BUTTON: 'withdrawal-modal-withdraw-button',
  CONFIRM_BUTTON: 'withdrawal-modal-confirm-button'
};

export const STATUS_OPTIONS = [
  'received',
  'processing',
  'completed',
  'rejected',
  'returned'
];

export const errorLookupTable = {
  'end_to_end_id must be uniq': 'End-to-end ID must be unique'
};
